import { indexTopics } from '@/pages/home/mocks/data';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3">
            专题导航
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">八卦专题合集</h2>
          <p className="text-foreground-500 mt-2 text-sm">按主题分类浏览，快速找到你感兴趣的八卦内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexTopics.map((topic) => (
            <a
              key={topic.id}
              href="#index"
              className="group relative p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              {topic.hot && (
                <span className="absolute top-3 right-3 px-2 py-0.5 bg-primary-500 text-white text-[10px] font-bold rounded whitespace-nowrap">
                  HOT
                </span>
              )}
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${topic.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                {topic.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">{topic.desc}</p>
              <span className="text-xs text-primary-500 font-medium">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}